import { render } from "./AppDialog.vue?vue&type=template&id=d2f1561e&scoped=true"
import script from "./AppDialog.vue?vue&type=script&lang=js"
export * from "./AppDialog.vue?vue&type=script&lang=js"

import "./AppDialog.vue?vue&type=style&index=0&id=d2f1561e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2f1561e"]])

export default __exports__